import React, { Component } from 'react'

import { Tab } from 'semantic-ui-react'

import { FeedContentBrowser } from './FeedContentBrowser'
import { findFeedsForApi } from '../../all_cards/aufschaltung.js'
import { EventEmitter } from '../error_handling'

class ApiJsonContentBrowser extends Component {
  constructor (props) {
    super(props)
    const { context } = this.props
    const feeds = findFeedsForApi(context, 'jsonfeed')
    this.state = {
      activeIndex: 0,
      pollForFeedContent: Array(feeds.length).fill(false)
    }
  }

  componentDidMount () {
    EventEmitter.on('signalProfileTabChanged', this.onHandleTabChange)
    EventEmitter.on('signalFeedActivateToggled', this.onStartFeedPolling)
  }

  componentWillUnmount () {
    EventEmitter.off('signalProfileTabChanged', this.onHandleTabChange)
    EventEmitter.off('signalFeedActivateToggled', this.onStartFeedPolling)
  }

  setActiveIndex (activeIndex) {
    if (this.state.activeIndex !== activeIndex) {
      this.setState({ activeIndex: activeIndex })
    }
  }

  onHandleTabChange = ({activeIndex}) => {
    this.setActiveIndex(activeIndex)
  }

  onStartFeedPolling = () => {
    const { activeIndex, pollForFeedContent } = this.state
    pollForFeedContent[activeIndex] = true
    this.setState({pollForFeedContent: pollForFeedContent})
  }

  onStopFeedPolling = (feed) => {
    const { context } = this.props
    const feeds = findFeedsForApi(context, 'jsonfeed')
    const index = feeds.findIndex(fd => fd.id === feed.id)
    const { pollForFeedContent } = this.state
    pollForFeedContent[index] = false
    this.setState({pollForFeedContent: pollForFeedContent})
  }

  handleTabChange = ({activeIndex}) => {
    this.setActiveIndex(activeIndex)
    if (this.state.activeIndex !== activeIndex) {
      EventEmitter.emit('signalProfileTabChanged', { activeIndex: activeIndex })
    }
  }

  render () {
    const { activeIndex, pollForFeedContent } = this.state
    const { context } = this.props
    const feeds = findFeedsForApi(context, 'jsonfeed')
    if (!feeds) {
      return <div>Keine Ergebnisse</div>
    }
    return (
      <Tab menu={{ secondary: true, pointing: true, className: 'tab-wrapped'}} activeIndex={activeIndex}
        onTabChange={(e, {activeIndex}) => this.handleTabChange({activeIndex: activeIndex})}
        panes={feeds.map((f, index) => {
          return ({
            menuItem: f.nickname,
            render: () => (<FeedContentBrowser context={context} feed={f}
                            pollForFeedContent={pollForFeedContent[index]}
                            onStopFeedPolling={this.onStopFeedPolling} />)
          })
        })
      } />
    )
  }
}

export { ApiJsonContentBrowser }


// WEBPACK FOOTER //
// ./src/components/cards/ApiJsonContentBrowser.js